<dojo-master-list-view
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [canAdd]="true"
  [addButtonText]="'Invite User'"
  [showToolbarAddButton]="true"
  [agGridAdditionalClass]="'small-height'"
  [sizeSearchFiled]="defaultSize"
  (gridRowClicked)="openAdminUser($event)"
  (add)="onAddUser()"
  [hideSearch]="false"
  [hideNumberOfEntries]="true"
  (gridReady)="onGridReady($event)"
  [@appearOnTrigger]="!state.isLoading"
>
  <div additionalToolbarActions class="flex items-center">
    <h2 class="text-xl font-semibold text-gray-900 dark:text-gray-100">User Management</h2>
  </div>

  <div listViewSearchFields class="order-[-1] mr-2 flex items-center justify-center gap-2">
    <span class="text-sm">Exclude Internal Users</span>
    <mat-slide-toggle [formControl]="excludeInternalUsersCtrl" class="small" color="primary"> </mat-slide-toggle>
  </div>
</dojo-master-list-view>

@if (state.isLoading) {
  <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
    <dojo-loader />
  </div>
}
